import React, {FC} from "react"

import {Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import {useTheme} from "@irati/ui/src/global/useTheme"

import ProfilePicture from "@irati/ui/src/ProfilePicture"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {CelebrationsReportUser} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {Position, ImageWrapper, Wrapper} from "../../styled"

interface Props {
  celebratedUser: CelebrationsReportUser
  index: number
  isReceiver?: boolean
}

const CelebratedUser: FC<Props> = ({celebratedUser, index, isReceiver}) => {
  const {user, recognitionIds} = celebratedUser
  const theme = useTheme()

  const bgColor = () => {
    if (index === 0) {
      return theme.colors.utility.gold
    }
    if (index === 1) {
      return theme.colors.utility.silver
    }
    if (index === 2) {
      return theme.colors.utility.bronze
    }
    return theme.colors.utility.ink
  }

  return (
    <Flex direction="column" justifyContent="space-between" maxWidth="130px" height="100%">
      <div>
        <Wrapper>
          <Position justifyContent="center" alignItems="center" bgColor={bgColor()}>
            <Body color={theme.colors.greys.white}>#{index + 1}</Body>
          </Position>
          <ImageWrapper>
            <ProfilePicture user={user} size={100} />
          </ImageWrapper>
        </Wrapper>
        <Body textAlign="center" marginTop={1}>
          {firstnameLastname(user)}
        </Body>
      </div>
      <Body textAlign="center" small>
        {!isReceiver ? (
          <FormattedMessage
            id="admin.components.dashboard.reporting.recognition.modal.recognitionsGiven"
            values={{given: recognitionIds?.length}}
          />
        ) : (
          <FormattedMessage
            id="admin.components.dashboard.reporting.recognition.modal.recognitionsReceived"
            values={{received: recognitionIds?.length}}
          />
        )}
      </Body>
    </Flex>
  )
}

export default CelebratedUser
